module.exports = __webpack_public_path__ + "img/Search_more.1d1710d7.svg";